import { CheckCircle2, CircleAlert, Info, TriangleAlert } from "lucide-react";

const LEVELS = [
  ["errors", "Errori bloccanti", CircleAlert, "border-red-200 bg-red-50/60", "text-red-700"],
  ["warnings", "Avvisi", TriangleAlert, "border-amber-200 bg-amber-50/60", "text-amber-800"],
  ["info", "Note", Info, "border-slate-200 bg-slate-50", "text-slate-600"],
];

function Issue({ it, Icon, tone }) {
  return (
    <li className="py-2.5" data-testid={`check-${it.code}`}>
      <p className={`flex items-start gap-2 text-sm font-medium ${tone}`}><Icon size={15} className="mt-0.5 shrink-0" />{it.title}{it.count > 0 && <span className="text-xs font-normal text-slate-500">· {it.count} {it.count === 1 ? "pagina" : "pagine"}</span>}</p>
      <p className="ml-6 mt-0.5 text-xs text-slate-600">{it.detail}</p>
      {it.pages?.length > 0 && <p className="ml-6 mt-1 flex flex-wrap gap-1">{it.pages.map((p) => <code key={p} className="rounded bg-white px-1.5 py-0.5 text-[11px] text-slate-600 ring-1 ring-slate-200">{p}</code>)}</p>}
    </li>
  );
}

export default function ChecksList({ checks, compact = false }) {
  if (!checks) return <p className="text-sm text-slate-500">Controlli non ancora disponibili: compila il sito.</p>;
  return (
    <div className="space-y-3" data-testid="checks-list">
      {LEVELS.map(([k, label, Icon, box, tone]) => checks[k]?.length > 0 && (compact ? k !== "info" : true) && (
        <div key={k} className={`rounded-lg border px-4 py-1 ${box}`} data-testid={`checks-${k}`}>
          <p className={`pt-2 text-[11px] font-semibold uppercase tracking-wider ${tone}`}>{label} · {checks[k].length}</p>
          <ul className="divide-y divide-white/70">{checks[k].map((it) => <Issue key={it.code} it={it} Icon={Icon} tone={tone} />)}</ul>
        </div>
      ))}
      {!compact && checks.passed?.length > 0 && (
        <div className="rounded-lg border border-emerald-200 bg-emerald-50/50 px-4 py-3" data-testid="checks-passed">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-emerald-700">Superati · {checks.passed.length}</p>
          <ul className="mt-2 grid gap-1 sm:grid-cols-2">{checks.passed.map((p) => <li key={p} className="flex items-center gap-2 text-xs text-emerald-800"><CheckCircle2 size={13} />{p}</li>)}</ul>
        </div>
      )}
    </div>
  );
}
